import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IOperatorTail } from 'src/models/operator-tail.model';
import style from './operator-tail-number-relationship-list.module.scss';
import OperatorTailAdd from '../operator-tail-number-relationship-add/operator-tail-number-relationship-add.component';
import OperatorTailEdit from '../operator-tail-number-relationship-edit/operator-tail-number-relationship-edit.component';
import OperatorTailDelete from '../operator-tail-number-relationship-delete/operator-tail-number-relationship-delete.component';

type IProp = {
  data: IOperatorTail[];
  loading: boolean;
};

const OperatorTailListView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IOperatorTail>[] = [
    {
      title: Lang.LBL_OPERATOR_NAME,
      index: 'Operator.name',
      width: '35%',
    },
    {
      title: Lang.LBL_TAIL_NUMBER,
      index: 'TailNumber.tailNumber',
      width: '50%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <OperatorTailEdit data={value} />
          <OperatorTailDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IOperatorTail, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader
          as="h1"
          content={Lang.TTL_OPERATOR_TAIL_NUMBER_RELATIONSHIP}
        />
        <OperatorTailAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default OperatorTailListView;
